import React, { Component } from 'react';
import { observer, Provider } from 'mobx-react';
import { Link as ReachLink } from '@reach/router';

import UsedLinksStore from 'js/stores/pages/AdminDashboardPage/UsedLinksStore';
import { adminPanelColor } from 'js/config/style';

import LoadingSpinner from '../../LoadingSpinner';
import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import DropMenu from '../../DashPanel/DropMenu';

import Link from './Link';
import Icon from './Icon';
import Title from './Title';
import Text from './Text';

import Card from './Card';
import Display from './Display';
import Image from './Image';
import Details from './Details';
import Label from './Label';

import List from '../../List';
import Row from '../../List/Row';
import ListItem from '../../List/ListItem';
import ListMessage from '../../List/ListMessage';

import User from '../../Display/User';
import Transaction from './Transaction';
import Verified from './Verified';

@observer
export default class UsedLinks extends Component {
  used_links = UsedLinksStore.create({ id: parseInt(this.props['*']) });

  constructor(props) {
    super(props);
    this.used_links.load();
  }

  render() {
    const used_links = this.used_links;
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>
            <Link to="/admin/used_links">Used links</Link>
            {used_links.used_links && (
              <>
                <Icon name="chevron-right" />
                <Text>{used_links.used_links}</Text>
              </>
            )}
          </Title>
        </Header>

        <Provider model={used_links}>
          <Content background={adminPanelColor}>
            {used_links.isLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                <Card>
                  <Display>
                    <Image logo_type={used_links.logo_type} logo={used_links.logo_src} />
                  </Display>

                  <Details>
                    <Label>Created</Label>
                    <div>{used_links.created_at}</div>

                    <Label>Bank account</Label>
                    <div>{used_links.bank_account}</div>

                    <Label></Label>
                    <div>
                      <Verified verified={used_links.is_verified} />
                    </div>
                  </Details>
                </Card>

                <div>
                  <Row cols={2}>
                    <User load={{ bank_account_id: used_links.id }} title="Owner" />
                  </Row>

                  <Row>
                    <List paginator={used_links.transactions} title="Transactions" icon="list" controls="more">
                      <div>
                        {used_links.transactions.transactions.length ? (
                          used_links.transactions.transactions.map(transaction => (
                            <ListItem key={transaction.id} to={`/admin/transactions/transaction/${transaction.id}`}>
                              <Transaction transaction={transaction} />
                            </ListItem>
                          ))
                        ) : (
                          <ListMessage>No transactions found</ListMessage>
                        )}
                      </div>
                    </List>
                  </Row>
                </div>
              </>
            )}
          </Content>
        </Provider>
      </DashPanel>
    );
  }
}
